import { Box, Typography } from '@mui/material';

export default function ApiKeys() {
  return (
    <Box sx={{ width: '100%' }}>
      <Typography variant='h6' fontWeight='500' sx={{ fontSize: { xs: '1.125rem', lg: 20 } }}>
        API Keys
      </Typography>
      <Typography sx={{ fontSize: { xs: '14px', lg: 16 } }} mt={0.5} color='secondary'>
        Manage API keys to authenticate requests to the Kickcall API.
      </Typography>
      <Box
        mt={4}
        py={6}
        display='flex'
        alignItems='center'
        justifyContent='center'
        border='1px dashed #E5E7EB'
        borderRadius={2}
        bgcolor='background.paper'
      >
        <Typography color='text.secondary' fontSize={14}>
          API keys coming soon.
        </Typography>
      </Box>
    </Box>
  );
}
